import { useMemo } from "react";
import { io } from "socket.io-client";
export function useSocket(namespace, query = {}) {
    return useMemo(() => io(namespace, { query }), []);
}
